import HOC from '../HOC';
import {theVerge} from '../utility';

let TheVerge = () => {return null;}

export default HOC(TheVerge, theVerge);



// WEBPACK FOOTER //
// ./src/components/News/TheVerge.js